module.exports = __webpack_public_path__ + "static/search-aa2082440a45a64dd207e6e2ba340b2f.png";